

@if (this.archivos$ | async; as archivos ) {

    @for (archivo of archivos; track $index) {
        <ng-container >
            <!-- files List -->
                <div class="flex flex-row items-center justify-between w-full px-6 py-2 md:px-8 cursor-pointer border-b hover:bg-white dark:hover:bg-gray-800">
                    <div class="file-details flex flex-row items-center gap-2" (click)="mostrarArchivoDrawer(archivo)">
                        <div class="flex flex-0 items-center justify-center w-10 h-10 rounded-full overflow-hidden">
                             <div class="flex items-center justify-center w-full h-full rounded-full text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                <span class="text-xs">{{archivo.tipoDocumento}}</span>
                            </div>
                         
                        </div>
                        <span class="font-medium leading-5">{{archivo.documentoEsperado? archivo.documentoEsperado: archivo.nombreArchivo}}</span>
                        
                        @if(tipoTarea === tipology_Id_Gestiones && archivo.documentoOficial=== true){
                            <status-sticker [estado]="'Documento Oficial'" [color1]="'#2ecc71'" [color2]="'#fdfefe'"></status-sticker>
                        }
                    </div>
                    <div class="flex items-center gap-3">
                        @if(tipoTarea === tipology_Id_Gestiones 
                            && archivo.documentoOficial=== true 
                            && tareaDetalleModificada.origen.tipologiaId=== tipologiaIdOrigenTareaVA){

                            <button class="text-primary-500 underline underline-offset-2 font-medium" 
                                (click)="reenviarArchivoVA(archivo)">
                                Reenviar a VA
                            </button>
                        }
                        @if(tipoTarea === tipology_Id_Gestiones){
                            <button mat-icon-button (click)="eliminarArchivos(archivo)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        }
                    </div>
                    

                    @if(tipoTarea != tipology_Id_Gestiones){                     
                            <div class="flex flex-row items-end">
                            <button (click)="aceptarDocumento(archivo)" [disabled]="archivo.aprobado === true">
                                <mat-icon svgIcon="check_circle" [ngStyle]="{'color': archivo.aprobado === null ? 'gray' : archivo.aprobado === true ? 'green' : 'gray'}">
                                </mat-icon>
                            </button>
                            
                            <button (click)="rechazarDocumento(archivo)" [disabled]="archivo.aprobado === false">
                                <mat-icon svgIcon="cancel" [ngStyle]="{'color': archivo.aprobadoo === null ? 'gray' : archivo.aprobado === false ? 'red' : 'gray'}"></mat-icon>
                            </button>
                        </div>                       
                    }
                </div>
        </ng-container>

    }
    
    @empty {
        <div class="flex items-center justify-center h-64">
            <div class="text-2xl font-medium text-gray-400">No hay Archivos Asociados</div>
        </div>
    }

}
